import _ from 'lodash';
import moment from 'moment';
import api from '../api';
import numeral from 'numeral';
import KendoChart from '../core/charts/KendoChart';
import KendoGrid from '../core/charts/KendoGrid';
import { converter } from '../core/converter';
import dataBoard from '../core/databoard';
import dialogBox from '../core/dialog';
import infoBoard from '../core/infoboard';
import worldMap from '../core/map';
import templates from '../core/templates';
import translate, { translateText } from '../core/tools/translate';
import environment from '../environment';
import layers from '../layers';
import { customScrollbar } from '../shared';
import { notify, NOTIFY_TYPE } from '../shared/notify';
import { SummaryExtendedRankingSpreadsheet } from '../../spreadsheets/summary-extended-ranking';
import { FeaturePermission } from '../../constants/feature.permission.helper';
import Workspace from '../workspaces';
import { ControlType, Item } from '../workspaces/item';
import { ContextEnum } from '../../enuns/context.enum';
import { CompanySizeEnum } from '../../enuns/companySize.enum';
import { setExportActionCss } from '../../utils';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);
const LayerControls = name => require('../controls').get(name);
const LayerInfo = name => require('../info').get(name);
let _dataSourceSegment = null;
const _getContainer = (visible = false) =>
    infoBoard.createContainer({
        id: 'summary',
        name: translate('Common.Summary'),
        visible
    });

const _getTemplate = (type, values) => templates(`summary-${type}`, values);

const _addMessage = container => {
    $(container)
        .find('.ballon-container')
        .remove();
    $(container).prepend(
        _getTemplate('message', {
            host: environment.get('IMAGES_HOST')
        })
    );
};

const _resetView = options => {
    $('.panel-context').show();

    if (worldMap.hasLayer(LayerInfo('Stores').location)) {
        worldMap.removeLayer(LayerInfo('Stores').location);
    }

    layers.get('ServiceArea').clear();
    LayerControls('ServiceArea')
        .getLayer()
        .clear();

    if (options.layer) {
        options.layer.reset();
    }

    if (!LayerControls('ServiceArea').check()) {
        LayerControls('ServiceArea').check(true);
    }

    if (options.feature) {
        LayerControls('ServiceArea').add(options.feature);
    }
};

const dataSpreed = {
    options: null
};

export const storeNameToExcel = {
    Ranking_Market_Share: "Ranking Market Share (%) - Emplacamento",
    Montadoras: "Montadoras*",
    Emplacamento_Total: "Avaliação do período - Total Emplacamentos",
    Média_Mensal_de_Emplacamentos: "Média Mensal de Emplacamentos (MME)",
    Emplacamento_Total_por_Segmento: "EMPLACAMENTO TOTAL POR SEGMENTO",
    Monthly_Average_Registration: "Monthly Average Registration (MAR)",
    Period_Valuation_Total_Registration: "Period Valuation - Total Registration",
    Ranking_Market_Share_: "Ranking Market Share (%) - Registration",
    Automakers: "Automakers*",
    REGISTRATION_TOTAL_BY_SEGMENT: "Registration Total By Segment",
};

export const storeNameToExcelNames = Object.keys(storeNameToExcel).reduce((acc, curr) => {
    const excelName = storeNameToExcel[curr].replaceAll("_", " ");
    acc[excelName] = curr;
    return acc;
}, {});

class SummaryInfo {
    static _getFilename(text, date, title) {
        const baseName = storeNameToExcelNames[text] || " ";
        return `Summary_${title}_${baseName}_v${moment().format('YYYYMMDD')}`;
    }

    static getInstance() {
        if (!SummaryInfo._instance) {
            SummaryInfo._instance = new SummaryInfo();
        }

        return SummaryInfo._instance;
    }

    static _getIdSalesType(saleType) {
        switch (saleType) {
            case 'retail':
                return 1;

            case 'direct':
                return 2;

            case 'total':
                return 3;

            default:
                return 1;
        }
    }

    static _hasFullSummaryAccess() {
        const sales_type = environment.get('CONFIG').FILTERS.SALES_TYPE;
        return _.find(sales_type, ['value', 1] || _.find(sales_type, ['value', 3]));
    }

    init() {}

    _request(container, options) {
        const _logBtnAction = (actionName, options) => {
            api.general.log.action(ContextEnum.Summary, actionName, JSON.stringify({
              id: options.id,
              idSalesType: options.idSalesType,
              idLocaleType: options.type,
              name: options.name,
              label: options.label,
              segments: options.segments,
              startDate: options.startDate,
              endDate: options.endDate,
            }));
        };

        dataBoard.hide();
        const _processRequest = response => {
            if (!response) {
                infoBoard.dataUnavailable({
                    container,
                    message: translate('Error.DataUnavailableAlt'),
                    image: 'no_refresh'
                });
                return;
            }
            dataSpreed.options = options;

            response.title = options.title;
            const $layout = $(_getTemplate('view', response));
            $layout.appendTo(container);
            // $layout.find('.btn-tooltip').tooltip();

            const dateControl = this._addDatePicker(container, options);

            options.title = $(`<div>${options.title}</div>`).text();

            $layout.find('a').on('click', ev => ev.preventDefault());
            $layout.find('#summary-title-popup').popover();

            $layout.find('[role="tablist"]').scrollTabs({
                left_arrow_size: 22,
                right_arrow_size: 22,
                click_callback(ev) {
                    ev.preventDefault();
                    $(this)
                        .find('a')
                        .tab('show');
                }
            });
            $layout
                .find('[role="tablist"]')
                .find('.scroll_tab_first')
                .trigger('click');

            const charts = [];

            setTimeout(() => {
                const haveSalesTotal = environment.get("CONFIG.CLIENT_TOTAL_SALES");

                if (response.performance && response.performance.chart) {
                    let title = translate('Common.MonthlyAverageRegistration');
                    let filename = SummaryInfo._getFilename(title, dateControl, options.title);
                    let chart = {
                        container: $('#summary-performance-chart'),
                        data: {
                            data: response.performance.chart,
                            type: ['column', 'line', 'line'],
                            // simple: true
                            format: '{0:n2}',
                            gap: 0.25,
                            // opacity: .8
                            colors: [['#D1D5D8'], ['#3498DB'], ['#9b59b6']],
                            // label: true
                            legend: {
                                position: 'top',
                                visible: true
                            }
                        },
                        options: {
                            title,
                            filename,
                            width: 318,
                            convertTable: true,
                            autoheight: true,
                            autocoloring: false,
                            buttons: {
                                // table: true,
                                export: true
                            }
                        }
                    };
                    charts.push(new KendoChart(chart.container, chart.data, chart.options));

                    title = translate('Common.PeriodEvaluation');
                    if (!SummaryInfo._hasFullSummaryAccess()) {
                        title = translate('Common.PeriodEvaluationDirectSales');
                    }

                    filename = SummaryInfo._getFilename(title, dateControl, options.title);
                    chart = {
                        container: $('#summary-evaluation-chart'),
                        data: response.evaluation.table.dataSource,
                        options: {
                            title,
                            filename,
                            width: 318,
                            convertTable: false,
                            columns: response.evaluation.table.columns,
                            filterable: false,
                            autoheight: true,
                            scrollable: false,
                            // autocoloring: false,
                            buttons: {
                                // fullscreen:true,
                                export: true
                            }
                        }
                    };
                    charts.push(new KendoGrid(chart.container, chart.data, chart.options));
                }

                if (response.ranking && response.ranking.chart) {
                    const title = translate('Common.AutomakersRanking');
                    const filename = SummaryInfo._getFilename(title, dateControl, options.title);
                    let chart;

                    let datasourceAutomakersRanking = response.ranking.chart.columns;

                    if (haveSalesTotal) {
                        const columnsToRemove = ["varejo", "vendaDireta"];

                        datasourceAutomakersRanking = datasourceAutomakersRanking.filter(
                            col => !columnsToRemove.includes(col.field)
                        );
                    }

                    chart = {
                        container: $('#summary-registrations-chart'),
                        data: response.ranking.chart.dataSource,
                        options: {
                            title,
                            filename,
                            width: 318,
                            height: 232,
                            autocoloring: false,
                            format: '{0:n2}',
                            columns: datasourceAutomakersRanking,
                            buttons: {
                                export: true
                            }
                        }
                    };

                    let salesTypeDataSource = [
                        { text: translate('Common.Total'), value: 'total' },
                        { text: translate('Common.Retail'), value: 'retail' },
                        { text: translate('Common.DirectSales'), value: 'direct' }
                    ];

                    let companySizesDataSource = [
                        { text: translate('Common.PersonSocial'), value: CompanySizeEnum.PersonSocial },
                        { text: translate('Common.SmallBusiness'), value: CompanySizeEnum.SmallBusiness },
                        { text: translate('Common.BigFleet'), value: CompanySizeEnum.BigFleet }
                    ];

                    if (!SummaryInfo._hasFullSummaryAccess()) {
                        salesTypeDataSource = _
                            .filter(salesTypeDataSource, v => v.value === 'direct')
                            .map(x => ({...x, text: translateText(x.text, false)}));
                    }

                    const _dataSource = salesTypeDataSource;
                    options.sales = !SummaryInfo._hasFullSummaryAccess() ? _dataSource[0].value : _dataSource[1].value;
                    options.salesText = !SummaryInfo._hasFullSummaryAccess() ? _dataSource[0].text : _dataSource[1].text;
                    options.idSalesType = _dataSource.length > 1 ? _dataSource[1].value : _dataSource[0].value;

                    // const _dataSource = !isAuthorized('Summary-complete')
                    //     ? _.filter(environment.get('CONFIG.FILTERS.SALES_TYPE'), v => v.value === 2)
                    //     : environment.get('CONFIG.FILTERS.SALES_TYPE');

                    const _errorRequest = err => {
                        console.log('ERROR: ', err);
                        notify(NOTIFY_TYPE.ERROR, translate('Error.DataUnavailableAlt'));
                    };

                    let _segmentFilters = [];

                    _.map(environment.get('CONFIG.FILTERS.SEGMENT'), segment => {
                        _segmentFilters.push({
                            text: translateText(segment.name, true),
                            value: segment.id
                        });
                    });

                    options.segments = [];
                    options.idsCompanySize = [];

                    const _getDataSourceText = (selected, datasource) =>
                        (selected && selected.length
                            ? selected.map(el => datasource.filter(x => x.value === el)[0].text)
                            : [translate("Common.All")]);

                    options.companySizesText = _getDataSourceText(options.idsCompanySize, companySizesDataSource);

                    const _successRequest = r => {
                        r.title = title + `${_.find(_dataSource, i => i.value === options.sales).text}`;
                        r.segmentsText = _getDataSourceText(options.segments, _segmentFilters);
                        r.companySizesText = _getDataSourceText(options.idsCompanySize, companySizesDataSource);
                        r.subtitle = options.title;
                        r.convertTable = false;
                        r.endDate = options.endDate.substr(0, 4);
                        r.sortable = true;
                        r.nameFile = `${environment.get('CONFIG.CLIENT')}_Tabela Evolução de Mercado_${options.title}_v${moment().format('YYYYMMDD')}`;
                        r.size = '50%';
                        r.filters = {
                            inputs: [
                                {
                                    id: 0,
                                    select: true,
                                    multiSelect: false,
                                    type: r.type,
                                    index: _.findIndex(_dataSource, i => i.value === options.sales),
                                    values: _dataSource,
                                    visible: !haveSalesTotal,
                                    change(e) {
                                        options.sales = e.sender.value();
                                        options.idSalesType = SummaryInfo._getIdSalesType(options.sales);
                                        _logBtnAction('Evolução de Mercado - Mudou Filtro', options);
                                    }
                                },
                                {
                                    id: 1,
                                    select: false,
                                    multiSelect: true,
                                    type: r.type,
                                    value: options.segments,
                                    values: _segmentFilters,
                                    placeholder: translate('Common.All'),
                                    visible: true,
                                    change(e) {
                                        options.segments = e.sender.value();
                                        r.segmentsText = _getDataSourceText(options.segments, _segmentFilters);
                                        _logBtnAction('Evolução de Mercado - Mudou Filtro', options);
                                    }
                                },
                                {
                                    id: 2,
                                    select: false,
                                    multiSelect: true,
                                    type: r.type,
                                    value: options.idsCompanySize,
                                    values: companySizesDataSource,
                                    placeholder: translate('Common.All'),
                                    visible: isAuthorized(FeaturePermission.INFO_SUMMARY.filterCompanySize) && !haveSalesTotal,
                                    change(e) {
                                        options.idsCompanySize = e.sender.value();
                                        r.companySizesText = _getDataSourceText(options.idsCompanySize, companySizesDataSource);
                                        _logBtnAction('Evolução de Mercado - Mudou Filtro', options);
                                    }
                                },
                                {
                                    id: 3,
                                    type: r.type,
                                    submit: true,
                                    visible: true,
                                    click(e) {
                                        e.preventDefault();
                                        api.summary.get
                                            .detailedMarketShare(options)
                                            .then(_successRequest, _errorRequest);
                                    }
                                }
                            ]
                        };
                        r.buttons = {
                            fullscreen: true,
                            export: isAuthorized(FeaturePermission.INFO_SUMMARY.exportExtendTableRanking)

                        };
                        dataBoard.show(r);
                    };

                    const exportCustomButton = {
                        icon:"download",
                        text:"custom",
                        name: translate('Action.ExportDetailed'),
                        callback: async function(mapId = worldMap.getCurrent()._id) {
                          if(_.size(_dataSourceSegment) > 0)
                            setTimeout(() => { (new SummaryExtendedRankingSpreadsheet(_dataSourceSegment, null, options.salesText, dataSpreed.options)).create().saveAsExcel(); }, 300);
                          else
                            notifyError(null,{ type: NOTIFY_TYPE.ERROR, text: 'Não foi possível realizar a exportação dos dados.' });
                        }
                    };

                    const _successRequestMarketSales = r => {
                        r.title = `${translate('Common.TotalRegistrationsBySegment')} - (${options.salesText}) - (${_getDataSourceText(options.idsCompanySize, companySizesDataSource)})`;
                        r.subtitle = options.title;
                        r.convertTable = false;
                        r.endDate = options.endDate.substr(0, 4);
                        r.sortable = true;
                        r.message = translate(`Message.SummaryMSCompare.${environment.get('CONFIG.CLIENT')}`, {
                            empty: true
                        });
                        r.size = '40%';
                        r.buttons = {
                            fullscreen: true,
                            // export: true,
                            custom: isAuthorized(FeaturePermission.INFO_SUMMARY.exportExtendTableSegment) ? exportCustomButton : undefined
                        };

                        if(SummaryInfo._hasFullSummaryAccess()){
                            r.filters = {
                                inputs: [
                                    {
                                        id: 0,
                                        select: true,
                                        type: r.type,
                                        index: _.findIndex(_dataSource, i => i.value === options.sales),
                                        values: _dataSource,
                                        visible: !haveSalesTotal,
                                        change(e) {
                                            _logBtnAction('Segmento Estendido - Mudou Filtro', options);
                                            options.sales = e.sender.value();
                                            options.idSalesType = SummaryInfo._getIdSalesType(options.sales);
                                            options.salesText = _dataSource[_.findIndex(_dataSource, i => i.value === options.sales)].text;
                                        }
                                    },
                                    {
                                        id: 1,
                                        select: false,
                                        multiSelect: true,
                                        type: r.type,
                                        value: options.idsCompanySize,
                                        values: companySizesDataSource,
                                        placeholder: translate('Common.All'),
                                        visible: isAuthorized(FeaturePermission.INFO_SUMMARY.filterCompanySize) && !haveSalesTotal,
                                        change(e) {
                                            options.idsCompanySize = e.sender.value();
                                            options.companySizesText = _getDataSourceText(options.idsCompanySize, companySizesDataSource),
                                            _logBtnAction('Segmento Estendido - Mudou Filtro', options);
                                        }
                                    },
                                    {
                                        id: 2,
                                        type: r.type,
                                        submit: true,
                                        visible: !haveSalesTotal,
                                        click(e) {
                                            e.preventDefault();
                                            api.summary.get
                                                .detailedMarketSales(options)
                                                .then(_successRequestMarketSales, _errorRequest);
                                        }
                                    }
                                ]
                            };
                        }

                        _dataSourceSegment = {
                            data: _.cloneDeep(r.dataSource.data),
                            footer: _.cloneDeep(r.dataFooter.data),
                            columns: _.cloneDeep(r.columns)
                        };
                        dataBoard.show(r);
                    };

                    const _successRequestInvasionIndicator = r => {
                        r.title = `${translate('Common.InvasionIndicator')} - (${options.salesText})`;
                        r.subtitle = options.title;
                        r.convertTable = false;
                        r.endDate = options.endDate.substr(0, 4);
                        r.sortable = true;
                        r.message = translate(`Message.SummaryMSCompare.${environment.get('CONFIG.CLIENT')}`, {
                            empty: true
                        });
                        r.size = '40%';
                        r.filters = {
                            inputs: [
                                {
                                    id: 0,
                                    select: true,
                                    type: r.type,
                                    index: _.findIndex(_dataSource, i => i.value === options.sales),
                                    values: _dataSource,
                                    visible: true,
                                    change(e) {
                                        _logBtnAction('Indicador de Invasão - Mudou Filtro', options);
                                        options.sales = e.sender.value();
                                        options.idSalesType = SummaryInfo._getIdSalesType(options.sales);
                                        options.salesText = _dataSource[_.findIndex(_dataSource, i => i.value === options.sales)].text;
                                        api.summary.get
                                            .invasionIndicator(options)
                                            .then(_successRequestInvasionIndicator, _errorRequest);
                                    }
                                }
                            ]
                        };
                        r.buttons = {
                            //fullscreen: true,
                            export: isAuthorized(FeaturePermission.INFO_SUMMARY.exportTableInvasion)
                        };
                        dataBoard.show(r);
                    };

                    const _successRequestIpcAutoDetails = r => {
                        r.title = translate('Common.IpcAutoDetailTitle');
                        r.subtitle = options.title;
                        r.convertTable = false;
                        r.endDate = options.endDate.substr(0, 4);
                        r.sortable = true;
                        r.buttons = {
                            //fullscreen: true,
                            export: true
                        };
                        dataBoard.show(r);
                    };

                    if (isAuthorized(FeaturePermission.INFO_SUMMARY.showRegistrationMktShare)) {
                        $('#summary-registrations-button')
                            .show()
                            .kendoButton({
                                click() {
                                    options.sales = _dataSource[0].value;
                                    _logBtnAction('Abrir - Evolução de Mercado', options);
                                    api.summary.get.detailedMarketShare(options).then(_successRequest, _errorRequest);
                                }
                            })
                            .data('kendoButton');
                    }

                    if (isAuthorized(FeaturePermission.INFO_SUMMARY.showRegistrationMktShare)) {
                        $('#summary-evaluation-button')
                            .show()
                            .kendoButton({
                                click() {
                                    _logBtnAction('Abrir - Tabela Segmentos Estendida', options);
                                    options.sales = !SummaryInfo._hasFullSummaryAccess() ? _dataSource[0].value : _dataSource[1].value;
                                    options.salesText = !SummaryInfo._hasFullSummaryAccess() ? _dataSource[0].text : _dataSource[1].text;
                                    options.idSalesType = !SummaryInfo._hasFullSummaryAccess()
                                        ? SummaryInfo._getIdSalesType(_dataSource[0].value)
                                        : SummaryInfo._getIdSalesType(options.idSalesType);

                                    api.summary.get
                                        .detailedMarketSales(options)
                                        .then(_successRequestMarketSales, _errorRequest);
                                }
                            })
                            .data('kendoButton');
                    }

                    if(isAuthorized(FeaturePermission.INFO_SUMMARY.showExtendTableInvasion)) {
                        $('#summary-invasion-button')
                        .show()
                            .kendoButton({
                                click() {
                                    _logBtnAction('Abrir - Indicador de Invasão', options);
                                    options.sales = !SummaryInfo._hasFullSummaryAccess() ? _dataSource[0].value : _dataSource[1].value;
                                    options.salesText = !SummaryInfo._hasFullSummaryAccess() ? _dataSource[0].text : _dataSource[1].text;
                                    options.idSalesType = !SummaryInfo._hasFullSummaryAccess() ? 2 : 1;
                                    api.summary.get
                                    .invasionIndicator(options)
                                    .then(_successRequestInvasionIndicator, _errorRequest);
                                }
                            })
                            .data('kendoButton');
                        }

                    charts.push(new KendoGrid(chart.container, chart.data, chart.options));
                }

                if (response.automakers && response.automakers.chart) {
                    const title = `${translate('Common.Automakers')}*`;
                    const filename = SummaryInfo._getFilename(title, dateControl, options.title);
                    let chart = {
                        container: $('#summary-automakers-chart'),
                        data: response.automakers.chart.dataSource,
                        options: {
                            title,
                            filename,
                            width: 318,
                            height: 362,
                            autocoloring: false,
                            format: '{0:n0}',
                            columns: response.automakers.chart.columns,
                            buttons: {
                                export: true
                            }
                        }
                    };
                    charts.push(new KendoGrid(chart.container, chart.data, chart.options));
                }

                if (response.registrations && _.size(response.registrations.values)) {
                    _.forEach(response.registrations.values, segment => {
                        const filename = title => SummaryInfo._getFilename(title, dateControl, options.title);
                        const idContainer = `#${segment.tab}-chart`;
                        const industryChart = () => {
                            const title = options.sales == 'direct' ? translate('Common.RegistrationDirectSaleBySegment') : translate('Common.RegistrationTotalBySegment');
                            return ({
                                container: $(`${idContainer}-absolute`),
                                data: {
                                    data: segment.chart,
                                    type: 'bar',
                                    label: true,
                                    simple: true,
                                    format: '{0:n0}',
                                    gap: 1,
                                    spacing: 0,
                                    colors: ['#B3E5FC', '#4FC3F7', '#03A9F4', '#0288D1', '#0277BD', '#01579B'],
                                    legend: {
                                        position: 'bottom',
                                        visible: true,
                                        align: 'left',
                                        orientation: 'vertical'
                                    }
                                },
                                options: {
                                    title,
                                    filename: filename(title),
                                    convertTable: true,
                                    height: segment.chart.getTotalRows() * 50,
                                    margin: {
                                        right: 40
                                    },
                                    buttons: {
                                        export: true
                                    }
                                }
                            });
                        };

                        const segmentChartBar = (isPercent = false, chart = segment.chart) => {
                            const type = isPercent ? '(%)' : `(${translate('Common.InitialQuantities')})`;
                            const title = `${translate('Common.RegistrationRankingPosition')} ${options.salesText} ${type}`;

							if (chart._tables[0].total === 0) {
								const container = $(`${idContainer}-${isPercent? 'percent' : 'absolute'}`);
								container.html(
									`<p class="no-data-period">${translate('Error.NoDataAvailablePeriod')}</p>`
								);
								return;
							}

                            return ({
                                container: $(`${idContainer}-${isPercent? 'percent' : 'absolute'}`),
                                data: {
                                    data: chart,
                                    type: 'bar',
                                    simple: true,
                                    format: isPercent ? '{0:p2}' : '{0:n0}',
                                    percent: isPercent,
                                    label: true,
                                    gap: 3,
                                    spacing: 1.2,
                                    colors: ['#3498DB'],
                                    legend: false
                                },
                                options: {
                                    title,
                                    filename: filename(title),
                                    convertTable: true,
                                    margin: {
                                        right: 40
                                    },
                                    buttons: {
                                        export: true
                                    },
									tooltip: 'none',
                                }
                            });
                        };

                        const segmentChartPie = () => {
                            const title = `${translate('Common.RegistrationRankingPosition')} ${options.salesText}`;

							if (segment.chartPie._tables[0].total === 0) {
								const container = $(`${idContainer}-pie`);
								container.html(
									`<p class="no-data-period">${translate('Error.NoDataAvailablePeriod')}</p>`
								);
								return;
							}

                            return ({
                                container: $(`${idContainer}-pie`),
                                data: {
                                    data: segment.chartPie,
                                    type: 'pie',
                                    simple: true,
                                    percent: true,
                                    legend: {
                                        visible: true,
                                        position: 'right',
                                        labels: {
                                            font: `10px 'Roboto Condensed', sans-serif`,
                                            //template: data => data.text
                                        },
                                    },
                                    tooltip: {
                                        template: ({dataItem}) => `${dataItem.category} - ${numeral(dataItem.value).format("0,0[.]0%")}`
                                    }
                                },
                                options: {
                                    title,
                                    filename: filename(title),
                                    convertTable: true,
                                    buttons: {
                                        export: true
                                    }
                                }
                            });
                        };

                        const registerActionsChartButtons = () => {
                            const typesCharts = ['absolute', 'percent', 'pie'];
                            const registerActionChartButtom = name => {
                                const btn = $(`#${segment.key}-${name}-chart-button`);
                                btn.on('click', e => {
                                    hideCharts();
                                    showChart(name);
                                    disabledBtns();
                                    btn.addClass("active");
                                });
                            };
                            const hideCharts = () => _.forEach(typesCharts, e => $(`#${segment.tab}-chart-${e}`).hide());
                            const showChart = name => $(`#${segment.tab}-chart-${name}`).show();
                            const disabledBtns = () => _.forEach(typesCharts, e => $(`#${segment.key}-${e}-chart-button`).removeClass("active"));

                            _.forEach(typesCharts, registerActionChartButtom);
                        };

                        const isIndustry = segment.title === translate('Common.Industry');
                        const registrationCharts = [isIndustry ? industryChart() : segmentChartBar()];

                        if(!isIndustry){
                            registrationCharts.push(segmentChartBar(true, segment.chartPercent));
                            registrationCharts.push(segmentChartPie());
                            registerActionsChartButtons();
                        }

                        _.forEach(registrationCharts.filter(c => c), c => charts.push(new KendoChart(c.container, c.data, c.options)));
                    });
                }
            }, 300);

            if (options.actions && options.actions.export) {
                setExportActionCss(160);
                $(options.actions.export).on('click', e => {
                    e.stopPropagation();
                    converter.csv({
                        name: `summary_${options.title}`,
                        type: 'summary',
                        id: options.id,
                        idType: options.type,
                        summaryName: options.name,
                        label: options.label,
                        data: response,
                        startDate: moment(dateControl.start.value()).format('YYYYMM'),
                        endDate:  moment(dateControl.end.value()).format('YYYYMM'),
                    });
                });
            }

            customScrollbar(container.find('.panel-group'));
        };

        const _error = err => {
            infoBoard.dataUnavailable({
                container,
                message: translate(err.message) || translate('Error.BadRequest'),
                image: 'no_actived'
            });
        };

        if (options.method === 'Quadrantes') {
            api.summary.get.blocks(options).then(_processRequest, _error);
        } else if (options.method === 'Draw') {
            api.summary.get.area(options).then(_processRequest, _error);
        } else {
            api.general.log.action(ContextEnum.Summary, 'Info - Acionar', JSON.stringify({ IdLocation: options.id }));
            api.summary.get.locations(options).then(_processRequest, _error);
        }
    }

    _addDatePicker(container, options) {
        let _yearDate;
        let _startDate;
        let _endDate;

        const startValue = environment.validate.date.start(options.startDate).toDate();
        const endValue = environment.validate.date.end(options.endDate).toDate();

        const yearChange = () => {
            const _firstMonth = moment(_yearDate.value())
                .startOf('year')
                .toDate();
            let _lastMonth = moment(_yearDate.value())
                .endOf('year')
                .toDate();
            if (_lastMonth > environment.get('CONFIG.FILTERS.ENDYEAR')) {
                _lastMonth = environment.get('CONFIG.FILTERS.ENDYEAR');
            }

            const _updateInputs = (input, value) => {
                input.min(_firstMonth);
                input.max(_lastMonth);
                input.value(value);
            };

            _updateInputs(_endDate, _lastMonth);
            _updateInputs(_startDate, _firstMonth);

            Workspace.addAction(new Item("#summary-tab input.datepicker-year", moment(_yearDate.value()).toDate(), ControlType.KendoDatePicker));
        };

        const startChange = () => {
            _endDate.min(_startDate.value());
            if (_endDate.value() < _startDate.value()) {
                _endDate.value(_startDate.value());
            }

            Workspace.addAction(new Item("#summary-tab input.datepicker-start", moment(_startDate.value()).toDate(), ControlType.KendoDatePicker));
        };

        const endChange = () => {
            _startDate.max(_endDate.value());
            if (_startDate.value() > _endDate.value()) {
                _startDate.value(_endDate.value());
            }

            Workspace.addAction(new Item("#summary-tab input.datepicker-end", moment(_endDate.value()).toDate(), ControlType.KendoDatePicker));
        };

        _yearDate = container
            .find('.datepicker-year')
            .kendoDatePicker({
                change: yearChange,
                start: 'decade',
                depth: 'decade',
                max: environment.get('CONFIG.FILTERS.ENDYEAR'),
                min: environment.get('CONFIG.FILTERS.STARTYEAR'),
                format: 'yyyy',
                value: startValue
            })
            .data('kendoDatePicker');

        _startDate = container
            .find('.datepicker-start')
            .kendoDatePicker({
                change: startChange,
                start: 'year',
                depth: 'year',
                max: environment.get('CONFIG.FILTERS.ENDYEAR'),
                min: moment(environment.get('CONFIG.FILTERS.ENDYEAR'))
                    .startOf('year')
                    .toDate(),
                format: 'MMM',
                value: startValue
            })
            .data('kendoDatePicker');

        _endDate = container
            .find('.datepicker-end')
            .kendoDatePicker({
                change: endChange,
                start: 'year',
                depth: 'year',
                max: environment.get('CONFIG.FILTERS.ENDYEAR'),
                min: environment.get('CONFIG.FILTERS.STARTYEAR'),
                format: 'MMM',
                value: endValue
            })
            .data('kendoDatePicker');

        const submit = container.find('[name="summary-period"]');

        yearChange();
        _startDate.value(startValue);
        _endDate.value(endValue);

        submit.on('click', e => {
            e.preventDefault();
            options.startDate = moment(_startDate.value()).format('YYYYMM');
            options.endDate = moment(_endDate.value()).format('YYYYMM');
            this.create(options);

            api.general.log.action(
              ContextEnum.Summary,
              'Mudou Período',
              JSON.stringify({ IdLocale: options.id, InitialDate: options.startDate, EndDate: options.endDate }));
            Workspace.addAction(new Item('#summary-tab [name="summary-period"]', '', ControlType.InputButton));
        });

        return {
            start: _startDate,
            end: _endDate
        };
    }

    create(options = null) {
        const container = _getContainer(options ? options.visible : false);

        if (!isAuthorized(FeaturePermission.INFO_SUMMARY.show)) {
            infoBoard.dataUnavailable({
                container,
                message: translate('Error.NoDataAvailable'),
                image: 'no_data'
            });
            return;
        }

        if (!options || !options.id) {
            _addMessage(container);
            if (options.container) {
                _addMessage(options.container);
            }
            return;
        }

        infoBoard.open();

        const actions = infoBoard.createActions(
            {
                export: {
                    value: isAuthorized(FeaturePermission.INFO_SUMMARY.export),
                    label: translate('Action.ExportSummary')
                }
            },
            'Summary'
        );
        actions.layout.appendTo(container);

        options.actions = actions;
        options.title = options.title || options.name;

        this._request(container, options);
    }

    recalculate(options) {
        const size = options.value / 1000 || 12;

        const values = {
            id: options.id,
            title: translate('Common.InfluenceArea'),
            update: options.update,
            radius: [
                {
                    id: 1,
                    size: Math.round((size / 10) * 3 * 100) / 100,
                    disabled: true
                },
                {
                    id: 2,
                    size: Math.round((size / 10) * 6 * 100) / 100,
                    disabled: true
                },
                {
                    id: 3,
                    size
                }
            ]
        };

        const actions = {
            cancel(e) {
                e.preventDefault();
                if (options.controls && options.controls.switch && options.controls.switch.input) {
                    try {
                        options.controls.switch.input.enable(true);
                    } catch (err) {
                        console.error(err);
                    }
                }

                options.layer = null;
                _resetView(options);
            },

            submit(form, e) {
                e.preventDefault();
                if (options.controls && options.controls.switch && options.controls.switch.input) {
                    try {
                        options.controls.switch.input.enable(true);
                    } catch (err) {
                        console.error(err);
                    }
                }

                const callback = () => _resetView(options);

                const data = form.serializeObject();
                data.Id = Number(options.id);
                data.geojson = layers.get('ServiceArea').toGeoJSON();

                if (options.update) {
                    api.store.update.serviceArea(data, callback);
                }
            },

            calculate: (form, e) => {
                e.preventDefault();
                if (options.controls && options.controls.switch && options.controls.switch.input) {
                    try {
                        options.controls.switch.input.enable(false);
                    } catch (err) {
                        console.error(err);
                    }
                }

                LayerControls('ServiceArea').check(false);

                const _handleSuccess = response => layers.get('ServiceArea').setFeatures(response, true);

                const _handleError = () => {
                    notify(NOTIFY_TYPE.ERROR, translate('Error.FailGenerateArea'));
                };

                this.calculateTradeArea(form, options.latlng).then(_handleSuccess, _handleError);
            }
        };

        dialogBox.tradearea(values, actions);
    }

	deleteServiceArea(options) {
        const callback = () => _resetView(options);
		const data = {
			Id: Number(options.id)
		};
		api.store.del.serviceArea(data, callback);
	}

    calculateTradeArea(form, latlng, target) {
        if (!target) {
            target = $(form)
                .find('input[name="TipoTradeArea"]:checked')
                .val();
        }

        const { lat, lng } = latlng;

        const rawBreaks = [
            $(form).find('input[name="Anel1"]').val(),
            $(form).find('input[name="Anel2"]').val(),
            $(form).find('input[name="Anel3"]').val()
        ];

        const breaks = rawBreaks
            .map(v => parseFloat(v))
            .filter(v => !isNaN(v) && v >= 1);

        if (breaks.length === 0) {
            notify(NOTIFY_TYPE.ERROR, translate('Error.NotValidRadius'));            
            return Promise.reject(new Error('Invalid radius'));
        }

        const maxBreak = Math.max(...breaks);

        if (maxBreak > 100 && _.some([1, 3], v => v === parseInt(target))) {
            alert(translate('Error.NotValidDistanceKmPoint'));
            return Promise.reject(new Error(translate('Error.NotValidDistanceKmPoint')));;
        } 

        if (maxBreak > 60 && parseInt(target) === 2) {
            alert(translate('Error.NotValidDistanceTimePoint'));
            return Promise.reject(new Error(translate('Error.NotValidDistanceTimePoint')));;
        }

        return api.store.get.serviceArea(lat, lng, breaks.toString(), target);
    }
}

export default SummaryInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/SummaryInfo.js